import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import api from "@/lib/api";

export default function Collections() {
  const { t } = useLanguage();
  const [collections, setCollections] = useState([]);
  useEffect(() => {
    api.get("/collections").then((r) => setCollections(r.data.collections)).catch(() => {});
  }, []);

  return (
    <div data-testid="collections-page">
      <div className="border-b border-border bg-secondary/30">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 text-center">
          <p className="overline text-gold mb-3">{t("Curated Worlds")}</p>
          <h1 className="font-serif text-5xl sm:text-6xl font-light tracking-tight">{t("The Collections")}</h1>
          <p className="text-muted-foreground mt-5 max-w-xl mx-auto">
            {t("Each M&A Jewelry collection tells its own story — from the eternal solitaire to the boldest statement piece.")}
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 grid md:grid-cols-2 gap-6">
        {collections.map((c, i) => (
          <Link
            key={c.name}
            to={`/collections/${encodeURIComponent(c.name)}`}
            className="group relative overflow-hidden aspect-[16/11] bg-secondary"
            data-testid={`collection-card-${c.name}`}
          >
            <img src={c.image} alt={c.name} loading="lazy" className="hover-zoom-img h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <div className="absolute bottom-0 left-0 p-8">
              <h2 className="font-serif text-4xl text-white">{c.name}</h2>
              <p className="text-white/70 text-sm mt-2 inline-flex items-center gap-2 group-hover:text-gold transition-colors">
                {c.count} {t("pieces — Explore")} <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
